﻿import React from 'react';
import { str_isEmpty } from '@Util/Utils';
import { Checkbox_Props } from '@Util/Types';

export default function Checkbox(props: Checkbox_Props): JSX.Element {
    function generate_element_class(): string {
        let class_str: string = "Form_Row Form_Row_Checkbox";

        if (!str_isEmpty(props?.className)) {
            class_str += ` ${props.className}`;
        }

        if (props.error) {
            class_str += " Form_Row--Error";
        }

        return class_str;
    }

    return (
        <div className={generate_element_class()}>
            <label htmlFor={props.id}>
                <input
                    type="checkbox"
                    checked={props.checked}
                    onChange={props.onChange}
                    id={props.id}
                    name={props.id}
                />
                { props.label }
            </label>
        </div>
    )
}